export class AusenciaPorAno {
  ano: string;
  periodoOmissao: string[] = new Array<string>(13).fill('-');
}
